import Breadcrumbs from "@erecht24/frontend-kit/theme/components/breadcrumbs/Breadcrumbs";
import {STEP_PAYMENT, STEP_PAYMENT_PROVIDER_CHANGE, STEP_PLAN} from "../Constants";
import {useContext} from "react";
import {StateContext} from "../Contexts";
import {goto} from "../Util/goto";
import {track} from "../Util/tracking";

export default function (props) {
    /** @type CheckoutState */
    const state = useContext(StateContext);

    return <div>
        <div className="hidden xl:block">
            <Breadcrumbs>
                <button
                    className={state.step === STEP_PLAN ? `text-blue-dark cursor-default` : ``}
                    onClick={() => track(
                        () => goto(state, STEP_PLAN),
                        'checkout',
                        'navigation',
                        'checkout_menu',
                        'tariff'
                    )}
                >Tarif wechseln</button>
                {state.paymentProviderChangeModeEnabled &&
                    <button
                        className={state.step === STEP_PAYMENT_PROVIDER_CHANGE ? `text-blue-dark cursor-default` : ``}
                        onClick={() => track(
                            () => goto(state, STEP_PAYMENT_PROVIDER_CHANGE),
                            'checkout',
                            'navigation',
                            'checkout_menu',
                            'ds24migration'
                        )}
                    >Kündigung alter Tarif</button>
                }
                <button
                    className={state.step === STEP_PAYMENT ? `text-blue-dark cursor-default` : ``}
                    onClick={() => track(
                        () => goto(state, STEP_PAYMENT),
                        'checkout',
                        'navigation',
                        'checkout_menu',
                        'payment'
                    )}
                >Bestellung abschließen</button>
            </Breadcrumbs>
        </div>
        <div className="flex flex-row justify-center gap-[10px] xl:hidden">
            <button
                className={(state.step === STEP_PLAN ? `bg-blue` : `bg-gray-dark opacity-25`) + ` block w-2.5 h-2.5 rounded-[10px]`}
                onClick={() => track(
                    () => goto(state, STEP_PLAN),
                    'checkout',
                    'navigation',
                    'checkout_menu',
                    'tariff'
                )}
            >
                <span className="sr-only">Tarif wechseln</span>
            </button>
            {state.paymentProviderChangeModeEnabled &&
                <button
                    className={(state.step === STEP_PAYMENT_PROVIDER_CHANGE ? `bg-blue` : `bg-gray-dark opacity-25`) + ` block w-2.5 h-2.5 rounded-[10px]`}
                    onClick={() => track(
                        () => goto(state, STEP_PAYMENT_PROVIDER_CHANGE),
                        'checkout',
                        'navigation',
                        'checkout_menu',
                        'ds24migration'
                    )}
                >
                    <span className="sr-only">Kündigung alter Tarif</span>
                </button>
            }
            <button
                className={(state.step === STEP_PAYMENT ? `bg-blue` : `bg-gray-dark opacity-25`) + ` block w-2.5 h-2.5 rounded-[10px]`}
                onClick={() => track(
                    () => goto(state, STEP_PAYMENT),
                    'checkout',
                    'navigation',
                    'checkout_menu',
                    'payment'
                )}
            >
                <span className="sr-only">Bestellung abschließen</span>
            </button>
        </div>
        <div className="text-3xl text-blue-dark text-center font-bold mt-5 mb-10 xl:hidden">
            {state.step === STEP_PLAN &&
                <>Tarif wechseln</>
            }
            {state.step === STEP_PAYMENT_PROVIDER_CHANGE &&
                <>Kündigung alter Tarif</>
            }
            {state.step === STEP_PAYMENT &&
                <>Bestellung abschließen</>
            }
        </div>
    </div>
}
